import { makeStyles, createStyles } from "@material-ui/styles";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Theme } from "react-select";
import useLandingFunctions from "../../../../../hooks/useLandingFunctions";
import { PFXBasicComponent } from "../../../../../models/Interfaces";
import { selectIsMobile } from "../../../../../redux/slices/cleverlynkSlice";
import { selectComponentDimensions } from "../../../../../redux/slices/landingSlice";

interface IVideo {
  data: PFXBasicComponent;
  id: string;
}

const Video = ({ data, id }: IVideo) => {
  const { width, height } = useSelector(selectComponentDimensions);
  const {} = useLandingFunctions();

  const isMobile = useSelector(selectIsMobile);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      frame: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
      },
      root: {
        height: !isMobile ? height : height * 0.75,
        width,
        transition: "height 400ms",
        backgroundColor: "#ffffff",
        position: "relative",
      },
      overlay: {
        top: 0,
        left: 0,
        width: "100%",
        position: "absolute",
        height: "100%",
        zIndex: 1000,
        padding: 30,
      },
    })
  );

  const classes = useStyles();

  return (
    <div id={`landing-component-${id}`} className={classes.root}>
      <iframe
        className={classes.frame}
        src={data.videoUrl}
        allowFullScreen={true}
        frameBorder={0}
        title="Video Embed"
      />
    </div>
  );
};
export default Video;
